import { InlineMath } from "react-katex";
import i18n from "../../../language/i18n";
import {
  constructInputWithSpecialExpressionList,
  readActivityDataField,
} from "../../../utilization/CatchtivityUtilization";
import { IActivitySolutionProps } from "../../../properties/ActivityProperties";
import MarkdownTable from "../body-contents/MarkdownTable";
import { splitMarkdownTables } from "../../../utilization/MarkdownTableUtilization";

const ActivitySolutionContent = ({
  activityTemplateType,
  data,
  hideTitleAndBorder = false,
}: IActivitySolutionProps & { hideTitleAndBorder?: boolean }) => {
  if (!activityTemplateType) return null;

  // Dual-read: prefers flat solutionMap; falls back to legacy <type>SolutionMap.
  const solutionMapString = readActivityDataField(data, activityTemplateType, "solutionMap");

  if (
    !solutionMapString ||
    !(
      solutionMapString.includes("[ONAYLI CEVAP]") ||
      solutionMapString.includes("[APPROVED ANSWER]") ||
      solutionMapString.includes("[GENEHMIGTE ANTWORT]")
    )
  )
    return null;

  let solutionMap;
  try {
    solutionMap = JSON.parse(
      solutionMapString
        .replace("\n[ONAYLI CEVAP]\n", "")
        .replace("\n[ONAYLI CEVAP]", "")
        .replace("[ONAYLI CEVAP]\n", "")
        .replace("[ONAYLI CEVAP]", "")
        .replace("\n[APPROVED ANSWER]\n", "")
        .replace("\n[APPROVED ANSWER]", "")
        .replace("[APPROVED ANSWER]\n", "")
        .replace("[APPROVED ANSWER]", "")
        .replace("\n[GENEHMIGTE ANTWORT]\n", "")
        .replace("\n[GENEHMIGTE ANTWORT]", "")
        .replace("[GENEHMIGTE ANTWORT]\n", "")
        .replace("[GENEHMIGTE ANTWORT]", "")
    );
  } catch (error) {
    console.error("Error parsing solution map:", error);
    return null;
  }

  if (!solutionMap || Object.keys(solutionMap).length === 0) return null;

  // The inline run of one text: **bold**, __underline__ and $$math$$.
  const renderInline = (text: string, runKey: string) => (
    <span key={runKey}>
      {constructInputWithSpecialExpressionList(text).map((inputPart, partIndex) => (
        <span
          key={`${runKey}_part_${partIndex}`}
          className={`${inputPart.isBold ? "am-bold" : ""} ${
            inputPart.isUnderline ? "am-underline" : ""
          }`}
        >
          {inputPart.isEquation ? (
            <span className="am-eq">
              <InlineMath math={inputPart.value} />
            </span>
          ) : (
            inputPart.value
          )}
        </span>
      ))}
    </span>
  );

  const renderContent = () => (
    <>
      {Object.keys(solutionMap).map((key) => {
          let currentItem;
          try {
            currentItem = JSON.parse(solutionMap[key]);
          } catch (error) {
            console.error(`Error parsing solution item at key ${key}:`, error);
            return null;
          }

          const { value } = currentItem;

          return (
            <div key={key} className="am-sol-item">
              {splitMarkdownTables(value).map((segment, segmentIndex) =>
                segment.kind === "table" ? (
                  <MarkdownTable
                    key={`${key}_tbl_${segmentIndex}`}
                    table={segment.table}
                    renderCell={(text, cellKey) => renderInline(text, `${key}_${cellKey}`)}
                  />
                ) : (
                  renderInline(segment.text, `${key}_${segmentIndex}`)
                ),
              )}
            </div>
          );
        })}
    </>
  );

  if (hideTitleAndBorder) {
    return renderContent();
  }

  return (
    <div className="am-sol-wrap">
      <div className="am-sol-box">
        <p className="am-section-title">{i18n.t("solution")}</p>
        {renderContent()}
      </div>
    </div>
  );
};

export default ActivitySolutionContent;
